package com.gsb.vyapar.bhagya.mqtt

import com.gsb.vyapar.bhagya.datasource.mqtt.MQTTCallback
import com.gsb.vyapar.bhagya.datasource.mqtt.MQTTManager

class MQTTManagerWeb {
    init {
        MQTTManager.onMQTTCallback { mqttCallback ->
            when (mqttCallback) {
                is MQTTCallback.CreateMqttClient -> {
                    createMQTTClient()
                    mqttCallback.status(Result.success(Unit))
                }
                is MQTTCallback.Connect -> {
                    connect()
                    mqttCallback.status(Result.success(Unit))
                }
                is MQTTCallback.Disconnect -> {
                    disconnect()
                    mqttCallback.status(Result.success(Unit))
                }
                is MQTTCallback.Publish -> {
                    publish(mqttCallback.topic, mqttCallback.message)
                    mqttCallback.status(Result.success(Unit))
                }
                is MQTTCallback.Subscribe -> {
                    subscribe(mqttCallback.topic)
                    mqttCallback.status(Result.success(Unit))
                }
                is MQTTCallback.UnSubscribe -> {
                    unsubscribe(mqttCallback.topic)
                    mqttCallback.status(Result.success(Unit))
                }
            }
        }
    }
}